module.exports = __webpack_public_path__ + "static/img/微信截图_20201208110934.514ccf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/微信截图_20201208110934.png
// module id = Yitb
// module chunks = 1